import {Individu} from '@Common/core/services';
import {ResponseForm} from '../../components/form/models/responsedemat.model';
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";
import {ResponseInstruction} from "app/demat/common/services/instructions/response-instruction.model";

export enum AvisEnum {
  favorable = 1,
  unfavorable = 2,
  suspended_other = 3
}

export namespace AvisEnum {
  export function toString(avisEnum: AvisEnum) {
    switch (avisEnum) {
      case AvisEnum.favorable:
        return 'Favorable';
      case AvisEnum.unfavorable:
        return 'Défavorable';
      case AvisEnum.suspended_other:
        return 'Suspendu / autre';
      default:
        return '<i>En attente</i>';
    }
  }

  export function toClass(avisEnum: AvisEnum) {
    switch (avisEnum) {
      case AvisEnum.favorable:
        return 'avis-favorable';
      case AvisEnum.unfavorable:
        return 'avis-unfavorable';
      case AvisEnum.suspended_other:
        return 'avis-suspended-other';
      default:
        return 'avis-waiting';
    }
  }
}

export enum TypeAvisEnum {
  extern = 1,
  public = 2,
  shared = 3
}

export namespace TypeAvisEnum {
  export function toString(typeAvisEnum: TypeAvisEnum) {
    switch (typeAvisEnum) {
      case TypeAvisEnum.extern:
        return 'Externe';
      case TypeAvisEnum.public:
        return 'Public';
      case TypeAvisEnum.shared:
        return 'Partagé';
      default:
        return 'N/A';
    }
  }

  export function toStringLong(typeAvisEnum: TypeAvisEnum) {
    switch (typeAvisEnum) {
      case TypeAvisEnum.extern:
        return "L'avis est à destination des gestionnaires";
      case TypeAvisEnum.public:
        return "L'avis est à destination du demandeur";
      case TypeAvisEnum.shared:
        return "L'avis est à destination du demandeur et des gestionnaires";
      default:
        return "L'avis, l'avis, l'avis, ....";
    }
  }
}

export interface ResponseAvis {
  id?: number;
  content_type_opinion?: number;
  dt_created?: string;
  dt_updated?: string;

  response?: number;
  response_obj?: ResponseForm;
  last_instruction_obj?: ResponseInstruction;

  expert_individu?: string;
  expert_individu_obj?: Individu;

  avis?: AvisEnum;
  avis_label?: string;

  type_avis?: TypeAvisEnum;
  motivation?: string;

  attachment_obj?: AttachmentModel[];

  message_question?: string; // le message envoyé pour demande d'avis
}

export interface ResponseAvisRequest extends ResponseAvis {
  message: string;
}
